import Cookies from "js-cookie";
import { z } from "zod";
import { PROJECT_CODE } from "./company.js";
import { getCookieDomain, getEnv } from "./env.js";
export const supportedLocales = [
    "de",
    "en",
    "hi",
    "fr",
    "it",
    "fi",
    "pl",
    "bg",
    "cs",
    "da",
    "es",
    "ru",
    "et",
    "pt",
    "ro",
    "sk",
    "tr",
    "vi",
];
supportedLocales;
export const supportedLocalesOptions = [
    { value: "en", label: "English", localLabel: "English" },
    { value: "de", label: "German", localLabel: "Deutsch" },
    { value: "hi", label: "Hindi", localLabel: "हिंदी" },
    { value: "it", label: "Italian", localLabel: "Italiano" },
    { value: "fr", label: "French", localLabel: "Français" },
    { value: "pl", label: "Polish", localLabel: "Polski" },
    { value: "bg", label: "Bulgarian", localLabel: "Български" },
    { value: "cs", label: "Czech", localLabel: "Čeština" },
    { value: "da", label: "Danish", localLabel: "Dansk" },
    { value: "es", label: "Spanish", localLabel: "Español" },
    { value: "ru", label: "Russian", localLabel: "Русский" },
    { value: "et", label: "Estonian", localLabel: "Eesti" },
    { value: "pt", label: "Portuguese", localLabel: "Português" },
    { value: "ro", label: "Romanian", localLabel: "Română" },
    { value: "sk", label: "Slovak", localLabel: "Slovenčina" },
    { value: "fi", label: "Finnish", localLabel: "Suomi" },
    { value: "tr", label: "Turkish", localLabel: "Türkçe" },
    { value: "vi", label: "Vietnamese", localLabel: "Tiếng Việt" },
];
export const LOCALE_KEY = "locale";
export const DEFAULT_LOCALE = "en";
/**
 * Get localStorage theme key based on deploy env
 * for vite env variables are prefixed with VITE_
 * for astro env variables are prefixed with PUBLIC_
 */
const getCookieKey = () => {
    return `${PROJECT_CODE}-${getEnv()}-${LOCALE_KEY}`;
};
export const setLocale = (locale) => {
    const storageKey = getCookieKey();
    Cookies.set(storageKey, locale, {
        expires: 365 * 10,
        domain: getCookieDomain(),
    });
};
export const getBrowserInitialLocale = () => {
    const userLocale = navigator.languages;
    for (const locale of userLocale) {
        for (const supportedLocale of supportedLocales) {
            if (locale.startsWith(supportedLocale)) {
                return supportedLocale;
            }
        }
    }
    return null;
};
export const getCookieInitialLocale = () => {
    const storageKey = getCookieKey();
    const savedLocale = Cookies.get(storageKey);
    if (supportedLocales.includes(savedLocale)) {
        return savedLocale;
    }
    return null;
};
export const getInitialLocale = () => {
    return getCookieInitialLocale() ?? getBrowserInitialLocale() ?? DEFAULT_LOCALE;
};
export function getLocaleString(locale, value) {
    if (!value)
        return "";
    return value[locale] ?? value[DEFAULT_LOCALE] ?? "";
}
export const LocaleSchema = z.enum(supportedLocales);
//# sourceMappingURL=locale.js.map